import { useState, useEffect, useRef } from "react";
import { useFormik } from "formik";
import DateInput from "../../lib/Common/DateInput";
import TextInputFormik from "../../lib/Common/TextInputFormik";
import { exchangeSchema } from "../../validations/schema";
import styles from "../../lib/Common/commonStyles";
import BackNextButtons from "../../lib/Common/BackNextButtons";
import Loader from "../../lib/Common/loader";
import Dropdown from "../../lib/Common/Dropdown";
import { useTranslation } from "react-i18next";
import { TooltipMessage } from "../../lib/Common/ToolTipmessage";

const ExchangeDetailsTab = ({
  formData,
  updateFormData,
  values,
  currentStep,
  setCurrentStep,
  showSave,
  providers,
  backStep,
}) => {
  const { t } = useTranslation();
  const [minDate, setMinDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [providerOptions, setProviderOptions] = useState([]);
  const [provider, setProvider] = useState(formData?.provider || "");
  const [show, setShow] = useState(false);
  const target = useRef(null);

  const [subscription, setSubscription] = useState(
    formData?.subscription || ""
  );

  function getDateAfterDays(days) {
    const today = new Date();
    let addedDays = 0;
    while (addedDays < days) {
      today.setDate(today.getDate() + 1);
      const day = today.getDay();
      if (day !== 0 && day !== 6) {
        addedDays++;
      }
    }
    return today.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  }

  function deliveryDate() {
    const selectedDate = new Date(formik?.values?.preferred_delivery_start);

    const min = getDateAfterDays(11);
    console.log(
      selectedDate,
      new Date(min),
      selectedDate < new Date(min),
      " selectedDate < min"
    );
    if (selectedDate < new Date(min)) {
      formik.setFieldValue("preferred_delivery_start", "");
    }

    setMinDate(min);
  }

  useEffect(() => {
    // getProviders();
    const today = new Date();
    today.setHours(0, 0, 0, 0); // optional normalization
    setMinDate(today);
    // setLoading(false);
  }, []);

  useEffect(() => {
    setProviderOptions(providers || []);
  }, [providers]);

  const formik = useFormik({
    initialValues: formData?.exchangeDetails || {},
    validationSchema:
      minDate && values?.customerType
        ? exchangeSchema(minDate, values?.customerType)
        : null,
    onSubmit: (values) => {
      updateFormData({
        ...formData,
        exchangeDetails: {
          ...formData?.exchangeDetails,
          ...values,
        },
        provider: provider,
        subscription: subscription,
      });
    },
  });
  useEffect(() => {
    // if (formData?.exchangeDetails?.subscription_reason) {
    //   console.log( formData?.exchangeDetails?.subscription_reason !=
    //     formik?.values?.subscription_reason, ` formData?.exchangeDetails?.subscription_reason !=
    //     formik?.values?.subscription_reason`)
    //   if (
    //     formData?.exchangeDetails?.subscription_reason !=
    //     formik?.values?.subscription_reason
    //   )
    //     formik.setFieldValue("preferred_delivery_start", "");
    // }
    // else {
    //    console.log( formData?.exchangeDetails?.preferred_delivery_start, ` formData?.exchangeDetails?.preferred_delivery_start`)
    //   formik.setFieldValue(
    //     "preferred_delivery_start",
    //     formData?.exchangeDetails?.preferred_delivery_start || ""
    //   );
    // }
    if (subscription == "Change Provider")
      formik.setFieldValue(
        "previous_provider",
        formData?.exchangeDetails?.previous_provider ||
          formik?.values?.previous_provider ||
          ""
      );
    else {
      formik.setFieldValue("previous_provider", "");
    }
    deliveryDate();
  }, [subscription]);
  const subscriptionReasons = [
    { id: "E01", label: "Move to new location" },
    { id: "E02", label: "New Site" },
    { id: "E03", label: "Change Provider" },
  ];

  return (
    <>
      {loading ? (
        <Loader loading={loading} />
      ) : (
        <div>
          <h2 className="fontSize32Regular lineHeight38 textgreen  mb-2 mb-md-5 heading-text">
            {t("Exchange Details")}
          </h2>
          <div className="mb-3 mb-md-5 ">
            <label className="form-label text-white fontSize14Medium mb-2 mb-md-3 lineHeight24">
              {t("Subscription Reason*")}
            </label>
            <div className="row">
              {subscriptionReasons.map((reason, index) => (
                <div key={reason.id} className="col-md-4 mb-2 ">
                  <button
                    type="button"
                    onClick={() => {
                      formik.setFieldValue("subscription_reason", reason.id);
                      setSubscription(reason.label);
                    }}
                    className={`w-100 borderRadius12 border-1 border-green fontSize16Medium lineHeight24 button_green`}
                    style={{
                      ...styles.optionButton,
                      ...(formik.values.subscription_reason === reason.id
                        ? styles.optionButtonSelected
                        : styles.optionButtonUnselected),
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor =
                        formik.values.subscription_reason === reason.id
                          ? "#23dc9f"
                          : "#522a7c";
                      e.target.style.color =
                        formik.values.subscription_reason === reason.id
                          ? "#421f66"
                          : "#ffffff";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor =
                        formik.values.subscription_reason === reason.id
                          ? "#23dc9f"
                          : "#421f66";
                      e.target.style.color =
                        formik.values.subscription_reason === reason.id
                          ? "#421f66"
                          : "#ffffff";
                    }}
                  >
                    {t(`${reason.label}`)}
                  </button>
                </div>
              ))}
            </div>
            {(formik.submitCount > 0 || formik.touched?.subscription_reason) &&
              formik.errors?.subscription_reason && (
                <p className="fontSize14Medium lineHeight1_2 text-pink mt-1">
                  {t(`${formik.errors?.subscription_reason}`)}
                </p>
              )}
          </div>
          <div className="row ">
            <div className="mb-2 mb-md-4 w-100">
              <DateInput
                min={minDate}
                label={t("Desired Delivery Date")}
                value={formik?.values?.preferred_delivery_start}
                onChange={(value) => {
                  if (value) {
                    const date = new Date(value);

                    // Format as dd/MM/yyyy
                    const day = String(date.getDate()).padStart(2, "0");
                    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
                    const year = date.getFullYear();

                    formik.setFieldValue(
                      "preferred_delivery_start",
                      `${year}-${month}-${day}`
                    );
                  } else {
                    formik.setFieldValue("preferred_delivery_start", "");
                  }
                }}
                required
              />
              {(formik.submitCount > 0 ||
                formik.touched?.preferred_delivery_start) &&
                formik.errors?.preferred_delivery_start && (
                  <p className="fontSize14Medium lineHeight1_2 text-pink mt-1 mb-0">
                    {t(`${formik.errors?.preferred_delivery_start}`)}
                  </p>
                )}
            </div>
          </div>
          <div className="row mb-1">
            <div className="col-md-6 mb-1">
              <div className="position-relative">
                <TextInputFormik
                  label={t("Meter ID")}
                  field="meterId"
                  formik={formik}
                  required={values?.customerType == "private" ? true : false}
                />
                <TooltipMessage
                  message="tooltip-message"
                  buttonClass="position-absolute border-0 bg-transparent cursor-pointer custom-tooltop-button custom-pink-button"
                />
              </div>
            </div>
            <div className="col-md-6 mb-1 ">
              <TextInputFormik
                label={t("Meteringpoint ID")}
                field="meteringPointId"
                formik={formik}
                required={values?.customerType == "private" ? true : false}
              />
            </div>
          </div>
          {formik.values?.subscription_reason == "E03" && (
            <div className="mb-3 mb-md-5">
              <Dropdown
                name="Current Provider"
                label={t("Current Provider")}
                value={
                  formik.values?.previous_provider &&
                  providerOptions.find(
                    (option) =>
                      option.value === formik.values?.previous_provider
                  )
                }
                placeholder=""
                options={providerOptions}
                onChange={(value) => {
                  formik.setFieldValue("previous_provider", value.value);
                  setProvider(value.label);
                }}
              />
              {(formik.submitCount > 0 || formik.touched?.previous_provider) &&
                formik.errors?.previous_provider && (
                  <div>
                    <p className="fontSize14Medium lineHeight1_2  text-pink mt-1 mb-0">
                      {t(`${formik.errors?.previous_provider}`)}
                    </p>
                  </div>
                )}
            </div>
          )}
          <BackNextButtons
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            onClick={async (nextStep) => {
              const errors = await formik.validateForm();
              formik.handleSubmit();
              if (Object.keys(errors).length == 0) {
                setCurrentStep(nextStep);
              }
            }}
            values={{ ...formData, exchangeDetails: formik.values, ...values }}
            backStep={backStep}
            showSave={showSave}
          />
        </div>
      )}
    </>
  );
};
export default ExchangeDetailsTab;
